import OtherPhysicianAutoComplete from './OtherPhysicianAutoComplete.view';

export default OtherPhysicianAutoComplete;
